import './SpellCheckPreview.sass';

import DOMPurify from 'dompurify';
import React from 'react';

import { spellCheckContent } from '../../lib/spellCheckContent';
import ReviewBlock from '../ReviewBlock/ReviewBlock';

export default function SpellCheckPreview({
  value = '',
  label = 'Spelling review',
  showNoErrors = false,
}) {
  if (!value || value === '<p><br></p>') return null;

  const checked = spellCheckContent(value);
  const hasErrors = checked.includes('class="misspelling"');

  if (!hasErrors && !showNoErrors) return null;

  return (
    <ReviewBlock
      label={label}
      className={hasErrors ? 'has-errors' : 'has-no-errors'}
    >
      {hasErrors ? (
        <div
          className="spell-preview"
          spellCheck={false}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(checked),
          }}
        />
      ) : (
        <div className="spell-preview-no-errors">
          <i className="fa fa-check" />
          <span>No spelling errors</span>
        </div>
      )}
    </ReviewBlock>
  );
}
